<template>
  <v-card :loading="loading">
    <v-window v-model="onboarding">
      <v-window-item>
        <v-card>
          <v-card-title class="subtitle-1 font-weight-bold px-6">
            {{ translations.participantDetails[lang] }}
            <v-spacer></v-spacer>
            <v-btn icon @click="$emit('cancel')">
              <v-icon v-text="icons.mdiClose"></v-icon>
            </v-btn>
          </v-card-title>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left"></th>
                  <th class="text-left"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, i) in accountInfo" :key="i">
                  <td>{{ translations[i][lang] }}</td>
                  <td v-if="typeof item == 'boolean'">
                    <v-icon v-if="item" v-text="icons.mdiCheckCircle" color="green"></v-icon>
                    <v-icon v-else v-text="icons.mdiCloseCircle" color="error"></v-icon>
                  </td>
                  <td v-else>{{ item }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>
      </v-window-item>
      <v-window-item>
        <v-card>
          <v-card-title class="subtitle-1 font-weight-bold px-6">
            {{ translations.customerDetails[lang] }}
            <v-spacer></v-spacer>
            <v-btn icon @click="$emit('cancel')">
              <v-icon v-text="icons.mdiClose"></v-icon>
            </v-btn>
          </v-card-title>
          <CustomerForm :mode="'readonly'" />
        </v-card>
      </v-window-item>
      <v-window-item v-if="participantInfo.transaction">
        <v-card>
          <v-card-title class="subtitle-1 font-weight-bold px-6">
            {{ translations.transactionInfo[lang] }}
            <v-spacer></v-spacer>
            <v-btn icon @click="$emit('cancel')">
              <v-icon v-text="icons.mdiClose"></v-icon>
            </v-btn>
          </v-card-title>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left"></th>
                  <th class="text-left"></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{ translations.transaction_id[lang] }}</td>
                  <td>{{ participantInfo.transaction.transaction_id }}</td>
                </tr>
                <tr>
                  <td>{{ translations.total_points[lang] }}</td>
                  <td>{{ participantInfo.transaction.total_points }}</td>
                </tr>
                <tr>
                  <td>{{ translations.total_price[lang] }}</td>
                  <td>{{ -1 * participantInfo.transaction.total_price }}€</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <v-container fluid>
            <v-data-iterator
              :items="participantInfo.transaction.transaction_items"
              hide-default-footer
              class="d-flex flex-column align-center"
            >
              <template v-slot:header>
                <v-toolbar class="mb-2" color="gray darken-5" dark flat style="width: 100%">
                  <v-toolbar-title>{{ translations.transaction_items[lang] }}</v-toolbar-title>
                </v-toolbar>
              </template>

              <template v-slot:default="props">
                <v-row class="d-flex justify-center" style="background-color: #272727; width: 100%">
                  <v-col
                    v-for="item in props.items"
                    :key="item.product_id"
                    cols="12"
                    xl="6"
                    lg="8"
                    md="12"
                  >
                    <v-card>
                      <v-card-title class="subheading font-weight-bold">
                        {{ item.product_name[lang] }}
                      </v-card-title>

                      <v-divider></v-divider>

                      <v-list dense>
                        <v-list-item>
                          <v-list-item-content>{{ translations.price[lang] }}:</v-list-item-content>
                          <v-list-item-content class="align-end">
                            {{ item.price }}€
                          </v-list-item-content>
                        </v-list-item>

                        <v-list-item>
                          <v-list-item-content
                            >{{ translations.points[lang] }}:</v-list-item-content
                          >
                          <v-list-item-content class="align-end">
                            {{ item.points }}
                          </v-list-item-content>
                        </v-list-item>

                        <v-list-item>
                          <v-list-item-content
                            >{{ translations.quantity[lang] }}:</v-list-item-content
                          >
                          <v-list-item-content class="align-end">
                            {{ item.quantity }}
                          </v-list-item-content>
                        </v-list-item>

                        <v-list-item v-if="item.total_litres > 0">
                          <v-list-item-content
                            >{{ translations.total_litres[lang] }}:</v-list-item-content
                          >
                          <v-list-item-content class="align-end">
                            {{ item.total_litres }}
                          </v-list-item-content>
                        </v-list-item>

                        <v-list-item>
                          <v-list-item-content
                            >{{ translations.reward_points_shared[lang] }}:</v-list-item-content
                          >
                          <v-list-item-content class="align-end">
                            <v-icon
                              v-if="item.reward_points_shared"
                              v-text="icons.mdiCheckCircle"
                              color="green"
                            ></v-icon>
                            <v-icon v-else v-text="icons.mdiCloseCircle" color="error"></v-icon>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-card>
                  </v-col>
                </v-row>
              </template>
            </v-data-iterator>
          </v-container>
        </v-card>
      </v-window-item>

      <v-window-item v-if="participantInfo.notifications && participantInfo.notifications[0]">
        <v-card>
          <v-card-title class="subtitle-1 font-weight-bold px-6">
            {{ translations.notifications[lang] }}
            <v-spacer></v-spacer>
            <v-btn icon @click="$emit('cancel')">
              <v-icon v-text="icons.mdiClose"></v-icon>
            </v-btn>
          </v-card-title>
          <v-container fluid>
            <v-data-iterator
              :items="participantInfo.notifications"
              hide-default-footer
              class="d-flex flex-column align-center"
            >
              <template v-slot:default="props">
                <v-row class="d-flex justify-center" style="width: 100%">
                  <v-col
                    v-for="item in props.items"
                    :key="item.product_id"
                    cols="12"
                    xl="6"
                    lg="8"
                    md="12"
                  >
                    <v-card>
                      <v-card-title class="subheading font-weight-bold">
                        {{ item.system_notification.toUpperCase() }}
                      </v-card-title>

                      <v-divider></v-divider>

                      <v-list dense>
                        <v-list-item>
                          <v-list-item-content> Status:</v-list-item-content>
                          <v-list-item-content class="align-end">
                            {{ item.status }}
                          </v-list-item-content>
                        </v-list-item>

                        <v-list-item>
                          <v-list-item-content
                            >{{ translations.notification_identifier[lang] }}:</v-list-item-content
                          >
                          <v-list-item-content class="align-end">
                            {{ item.identifier }}
                          </v-list-item-content>
                        </v-list-item>

                        <v-list-item v-if="item.title">
                          <v-list-item-content
                            >{{ translations.notification_title[lang] }}:</v-list-item-content
                          >
                          <v-list-item-content class="align-end">
                            {{ item.title[lang] }}
                          </v-list-item-content>
                        </v-list-item>

                        <v-list-item v-if="item.subject">
                          <v-list-item-content
                            >{{ translations.subject[lang] }}:</v-list-item-content
                          >
                          <v-list-item-content class="align-end">
                            {{ item.subject[lang] }}
                          </v-list-item-content>
                        </v-list-item>

                        <v-list-item v-if="item.body && item.body[lang]">
                          <v-list-item-content
                            >{{ translations.notification_body[lang] }}:</v-list-item-content
                          >
                          <v-list-item-content class="align-end">
                            {{ item.body[lang] }}
                          </v-list-item-content>
                        </v-list-item>

                        <v-list-item v-else-if="item.body" class="d-flex flex-column pr-1 pl-1">
                          <v-list-item-content style="width: 100%" class="pl-3"
                            >{{ translations.notification_body[lang] }}:</v-list-item-content
                          >
                          <v-list-item-content class="mw-inh" v-html="item.body" />
                        </v-list-item>
                      </v-list>
                    </v-card>
                  </v-col>
                </v-row>
              </template>
            </v-data-iterator>
          </v-container>
        </v-card>
      </v-window-item>

      <v-window-item v-if="participantInfo.coupon_claim">
        <v-card>
          <v-card-title class="subtitle-1 font-weight-bold px-6">
            {{ translations.couponInfo[lang] }}
            <v-spacer></v-spacer>
            <v-btn icon @click="$emit('cancel')">
              <v-icon v-text="icons.mdiClose"></v-icon>
            </v-btn>
          </v-card-title>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left"></th>
                  <th class="text-left"></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{ translations.coupon_claim_id[lang] }}</td>
                  <td>{{ participantInfo.coupon_claim.coupon_claim_id }}</td>
                </tr>
                <tr>
                  <td>{{ translations.expiration_date[lang] }}</td>
                  <td>{{ localizeDate(participantInfo.coupon_claim.expiration_date) }}</td>
                </tr>
                <tr>
                  <td>{{ translations.is_used[lang] }}</td>
                  <td>
                    <v-icon
                      v-if="participantInfo.coupon_claim.is_used"
                      v-text="icons.mdiCheckCircle"
                      color="green"
                    ></v-icon>
                    <v-icon v-else v-text="icons.mdiCloseCircle" color="error"></v-icon>
                  </td>
                </tr>
                <tr>
                  <td>{{ translations.voucher[lang] }}</td>
                  <td>{{ -participantInfo.coupon_claim.voucher }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>
      </v-window-item>
    </v-window>
    <v-divider></v-divider>

    <v-card-actions class="justify-space-between">
      <v-btn text @click="prev">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <v-item-group v-model="onboarding" class="text-center" mandatory>
        <v-item v-for="s in sections" :key="`btn-${s.value}`" v-slot="{ active, toggle }">
          <v-btn :input-value="active" icon @click="toggle">
            <v-icon v-text="s.icon"></v-icon>
          </v-btn>
        </v-item>
      </v-item-group>
      <v-btn text @click="next">
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import {
  mdiClose,
  mdiBell,
  mdiCash,
  mdiGift,
  mdiAccount,
  mdiCheckCircle,
  mdiCloseCircle,
  mdiCardAccountDetails,
} from '@mdi/js';

import translations from '@/utils/translations/loyaltyPanel/campaigns/viewCampaigns';
import { mapState, mapGetters } from 'vuex';
import CustomerForm from '@/components/loyaltyPanel/customers/CustomerForm.vue';

export default {
  name: 'ParticipantDetails',

  components: {
    CustomerForm,
  },

  mixins: [translations],

  data: () => ({
    icons: {
      mdiClose,
      mdiBell,
      mdiCash,
      mdiGift,
      mdiAccount,
      mdiCheckCircle,
      mdiCloseCircle,
      mdiCardAccountDetails,
    },
    onboarding: 0,
  }),

  computed: {
    ...mapState(['loading']),

    lang() {
      return this.$route.params.lang;
    },

    locale() {
      if (this.lang == 'el') return 'el-GR';
      if (this.lang == 'it') return 'it-IT';
      return 'en-GB';
    },
    ...mapGetters('loyaltyPanel/campaigns/viewCampaigns', ['participantInfo']),

    sections() {
      let sections = [
        { value: 'user', icon: this.icons.mdiAccount },
        { value: 'customer', icon: this.icons.mdiCardAccountDetails },
      ];
      if (this.participantInfo.transaction) {
        sections.push({ value: 'transactions', icon: this.icons.mdiCash });
      }
      if (this.participantInfo.notifications && this.participantInfo.notifications[0]) {
        sections.push({ value: 'notifications', icon: this.icons.mdiBell });
      }
      if (this.participantInfo.coupon_claim) {
        sections.push({ value: 'coupons', icon: this.icons.mdiGift });
      }
      return sections;
    },
    accountInfo() {
      let account = {};
      for (const i in this.participantInfo) {
        if (!['data', 'transaction', 'notifications', 'coupon_claim'].includes(i)) {
          account = { ...account, [i]: this.participantInfo[i] };
        }
      }
      return account;
    },
  },
  methods: {
    next() {
      this.onboarding = this.onboarding + 1 === this.sections.length ? 0 : this.onboarding + 1;
    },
    prev() {
      this.onboarding = this.onboarding - 1 < 0 ? this.sections.length - 1 : this.onboarding - 1;
    },
    localizeDate(date) {
      return date
        ? new Date(date).toLocaleString(this.locale, {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric',
          })
        : '';
    },
  },
};
</script>
<style>
.mw-inh {
  max-width: 100%;
  max-height: 500px;
  overflow: auto;
}
.mw-inh .u-row {
  max-width: 100% !important;
}
.mw-inh .u-row .u-col.u-col-100 {
  max-width: 100% !important;
  min-width: 320px !important;
}
</style>
